import { useGetApprovedEmployeePaysips } from "../../../../services/payroll.service";
import useUserStore from "../../../../state-management/useUserStore";
import TanStackEmployeeTable from "../../../../components/table/TanStackEmployeeTable";
import { recentPayColumns } from "../../payslips/tanstack-columns";
import { TableId } from "../../../../models/table-configuration.dto";

const RecentPayTable = () => {
	const companyProfile = (useUserStore().currentUser.user.companyProfiles ||
		[])[0];

	const { data, isLoading } = useGetApprovedEmployeePaysips(
		companyProfile?.employeeId as number,
		{ page: 1, limit: 8 } as any
	);

	return (
		<TanStackEmployeeTable
			tableId={TableId.RECENT_PAY}
			data={data?.data || []}
			columns={recentPayColumns}
			loading={isLoading}
			height="450px"
			pageSize={8}
			initialColumnVisibility={{}}
		/>
	);
};

export default RecentPayTable;
